export default "__VITE_ASSET__283fac6a__"